<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/a-pro-logo-dark.svg" alt="" height="17" />
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/a-pro-logo-light.svg" alt="" height="50" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/a-pro-logo-light.svg" alt="" height="46" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        [ngClass]="{ 'd-none': theme === 'horizontal' }"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!--      &lt;!&ndash; App Search&ndash;&gt;-->
      <!--      <form class="app-search d-none d-lg-block">-->
      <!--        <div class="position-relative">-->
      <!--          <input type="text" class="form-control" placeholder="{{'HEADER.SEARCH' | translate}}">-->
      <!--          <span class="bx bx-search-alt"></span>-->
      <!--        </div>-->
      <!--      </form>-->

      <div class="dropdown-mega d-none d-lg-block ms-2" dropdown>
        <button
          type="button"
          class="btn header-item"
          dropdownToggle
          data-toggle="dropdown"
          aria-haspopup="false"
          aria-expanded="false"
        >
          {{ "HEADER.QUICK_LINKS" | translate }}
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <div class="dropdown-menu dropdown-megamenu" *dropdownMenu>
          <div class="row">
            <div class="col-sm-9">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    {{ "MENUITEMS.APPS.TEXT" | translate }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a routerLink="/agents/list">{{
                        "MENUITEMS.AGENTS.TEXT" | translate
                      }}</a>
                    </li>
                    <!--                    <li>-->
                    <!--                      <a routerLink="/teams/list">{{ 'MENUITEMS.TEAMS.TEXT' | translate}}</a>-->
                    <!--                    </li>-->
                    <li>
                      <a routerLink="/properties/list">{{
                        "MENUITEMS.PROPERTIES.TEXT" | translate
                      }}</a>
                    </li>
                    <li>
                      <a routerLink="/buyers/list">{{
                        "MENUITEMS.BUYERS.TEXT" | translate
                      }}</a>
                    </li>
                    <li>
                      <a routerLink="/appointments/list">{{
                        "MENUITEMS.APPOINTMENTS.TEXT" | translate
                      }}</a>
                    </li>
                    <li>
                      <a routerLink="/contacts/list">{{
                        "MENUITEMS.CONTACTS.TEXT" | translate
                      }}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    {{ "MENUITEMS.FINANCE.TEXT" | translate }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a routerLink="/marketing/facebook-post">{{
                        "MENUITEMS.MARKETING_CAMPAIGN.FACEBOOK_POST.TEXT"
                          | translate
                      }}</a>
                    </li>
                    <li>
                      <a routerLink="/transactions//list">{{
                        "MENUITEMS.TRANSACTIONS.TEXT" | translate
                      }}</a>
                    </li>
                  </ul>
                </div>

                <!-- Show "Administration" section only for SuperAdmin or Admin roles -->
                @if (checkRoleAccess(showOnAdmin)) {
                  <div class="col-md-4">
                    <h5 class="font-size-14 mt-0">
                      {{ "MENUITEMS.ADMINISTRATION.TEXT" | translate }}
                    </h5>
                    <ul class="list-unstyled megamenu-list">
                      @if (checkRoleAccess(showOnSuperAdmin)) {
                        <li>
                          <a routerLink="/organizations/list">{{
                            "MENUITEMS.ORGANIZATIONS.TEXT" | translate
                          }}</a>
                        </li>
                      }
                      @if (checkRoleAccess(showOnAdmin)) {
                        <li>
                          <a
                            routerLink="/organizations/detail/{{
                              userData.organization_id
                            }}"
                            >{{
                              "MENUITEMS.ORGANIZATIONS.LIST.ORGANIZATION_DETAIL"
                                | translate
                            }}</a
                          >
                        </li>
                      }
                      @if (checkRoleAccess(showOnSuperAdmin)) {
                        <li>
                          <a routerLink="/users/list">{{
                            "MENUITEMS.USERS.LIST.USER_LIST" | translate
                          }}</a>
                        </li>
                      }
                      @if (checkRoleAccess(showOnSuperAdmin)) {
                        <li>
                          <a routerLink="/roles/list">{{
                            "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.ROLE_LIST"
                              | translate
                          }}</a>
                        </li>
                      }
                      @if (checkRoleAccess(showOnSuperAdmin)) {
                        <li>
                          <a routerLink="/permissions/list">{{
                            "MENUITEMS.ROLES_AND_PERMISSIONS.LIST.PERMISSION_LIST"
                              | translate
                          }}</a>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-sm-6">
                  <div>
                    <img
                      src="assets/images/megamenu-img.png"
                      alt=""
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block d-lg-none ms-2" dropdown>
        <button
          type="button"
          class="btn header-item noti-icon"
          id="page-header-search-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          dropdownToggle
          aria-expanded="false"
        >
          <i class="mdi mdi-magnify"></i>
        </button>
        <div
          class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          *dropdownMenu
          aria-labelledby="page-header-search-dropdown"
        >
          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="dropdown d-inline-block" dropdown>
        <button
          type="button"
          class="btn header-item"
          id="page-header-user-dropdown"
          dropdownToggle
        >
          @if (flagvalue === undefined) {
            <img src="{{ valueset }}" alt="Header Language" height="16" />
          } @else {
            <img src="{{ flagvalue }}" alt="Header Language" height="16" />
          }
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          @for (item of listLang; track $index) {
            <a
              href="javascript:void(0);"
              class="dropdown-item notify-item"
              (click)="setLanguage(item.text, item.lang, item.flag)"
              [ngClass]="{ active: cookieValue === item.lang }"
            >
              <img
                src="{{ item.flag }}"
                alt="user-image"
                class="me-1"
                height="12"
              />
              <span class="align-middle">{{ item.text }}</span>
            </a>
          }
          <!-- item-->
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button
          type="button"
          class="btn header-item noti-icon waves-effect"
          data-bs-toggle="fullscreen"
          (click)="fullscreen()"
        >
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <app-notification></app-notification>

      <div class="dropdown d-inline-block" dropdown>
        <button
          type="button"
          class="btn header-item"
          dropdownToggle
          id="page-header-user-dropdown-mobile"
        >
          <img
            class="rounded-circle header-profile-user bg-light"
            ngSrc="{{ userData?.profile_image || '#' }}"
            alt="{{ getProfileInitials(userData?.display_name) }}"
            height="256"
            width="256"
          />
          <span class="d-none d-xl-inline-block ms-1">{{
            userData?.display_name
          }}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" *dropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/users/detail/{{ userData?.id }}"
            ><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ "HEADER.LOGIN.PROFILE" | translate }}</a
          >
          <a
            class="dropdown-item text-danger"
            href="javascript: void(0);"
            (click)="logout()"
            ><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ "HEADER.LOGIN.LOGOUT" | translate }}</a
          >
        </div>
      </div>

      <!--      <div class="dropdown d-inline-block">-->
      <!--        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">-->
      <!--          <i class="bx bx-cog bx-spin"></i>-->
      <!--        </button>-->
      <!--      </div>-->
    </div>
  </div>
</header>
